import React, { useMemo } from 'react';
import { isAppModule, isAdModule, isEiModule, isOdpModule } from '@utils/constants';

export const generateRenderFor = (condition) => {
  return ({ children, fallback = null }) => {
    if (condition) {
      return children;
    }
    return fallback;
  };
};

// This is untested and not sure if the memo works as expected
const RenderFor = ({ condition, children, fallback }) => {
  const HOC = useMemo(() => generateRenderFor(condition), [condition]);
  return <HOC fallback={fallback}>{children}</HOC>;
};

RenderFor.App = React.memo(generateRenderFor(isAppModule));
RenderFor.EI = React.memo(generateRenderFor(isEiModule));
RenderFor.AI = React.memo(generateRenderFor(isAdModule));
RenderFor.EIandAI = React.memo(generateRenderFor(isEiModule || isAdModule));
RenderFor.Odp = React.memo(generateRenderFor(isOdpModule));

export default RenderFor;
